<template>
  <div id="app" :class="darkMode ? 'theme-dark' : 'theme-light'">
    <div v-if="error" class="connection-alert" role="status">{{ error }}</div>
    <Navbar />
    <div class="site-status" v-if="lowestTimer.npcName">
      <div class="site-frame">
        <span class="live-mark" aria-hidden="true"></span>
        <span>Next NPC loot level</span>
        <button type="button" @click="openNextLLnpc">
          {{ lowestTimer.npcName }} · {{ lowestTimer.timeStr }}
          <ArrowUpRight :size="15" aria-hidden="true" />
        </button>
      </div>
    </div>
    <main class="site-main"><router-view /></main>
    <footer class="site-footer">
      <div class="site-frame footer-inner">
        <span class="footer-brand"
          >PROMETHEUS <small>Community intelligence for Torn</small></span
        >
        <span
          >Made by
          <a
            href="https://www.torn.com/profiles.php?XID=2310495"
            target="_blank"
            rel="noopener noreferrer"
            >EddyCro</a
          >
          · Owned by
          <a
            href="https://www.torn.com/profiles.php?XID=483525"
            target="_blank"
            rel="noopener noreferrer"
            >-R3x-</a
          ></span
        >
      </div>
    </footer>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import { ArrowUpRight } from "lucide-vue";
import { mapMutations } from "vuex";
import { attackUrl } from "@/utils/tornLinks";

export default {
  name: "App",
  components: { Navbar, ArrowUpRight },
  data() {
    return {
      autoRefreshInterval: undefined,
      apiDataInterval: undefined,
      apiDataPending: false,
      lastApiRequestAt: 0,
      error: undefined,
    };
  },
  created() {
    this.updateNPCItems();
    this.autoRefreshInterval = setInterval(
      () => this.updateNPCCountdown(),
      1000
    );
    document.addEventListener("visibilitychange", this.onVisibilityChange);
    this.onVisibilityChange();
  },
  destroyed() {
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
    if (this.autoRefreshInterval) clearInterval(this.autoRefreshInterval);
    if (this.apiDataInterval) clearInterval(this.apiDataInterval);
  },
  methods: {
    ...mapMutations([
      "changeDarkMode",
      "updateNPCs",
      "updateNPCTimers",
      "updateNPCCountdown",
      "updateNPCItems",
    ]),
    onVisibilityChange() {
      if (this.apiDataInterval) clearInterval(this.apiDataInterval);
      this.apiDataInterval = undefined;
      if (document.hidden) return;
      this.getApiData();
      this.apiDataInterval = setInterval(() => this.getApiData(), 10000);
    },
    getApiData() {
      if (document.hidden || this.apiDataPending) return;
      const now = Date.now();
      if (now - this.lastApiRequestAt < 5000) return;
      this.lastApiRequestAt = now;
      this.apiDataPending = true;
      fetch(
        `${
          process.env.VUE_APP_API_BASE || "https://api.prombot.co.uk"
        }/api/npc`,
        { method: "GET" }
      )
        .then((res) => res.json())
        .then((data) => {
          this.updateNPCs(data);
          this.updateNPCTimers();
          this.error = undefined;
        })
        .catch(() => {
          this.error = "NPC data is unavailable. Retrying shortly.";
        })
        .finally(() => {
          this.apiDataPending = false;
        });
    },
    openNextLLnpc() {
      window.open(
        attackUrl(this.lowestTimer.npcID),
        "_blank",
        "noopener,noreferrer"
      );
    },
  },
  computed: {
    darkMode: {
      get() {
        return this.$store.state.darkMode;
      },
      set(value) {
        this.changeDarkMode(value);
      },
    },
    lowestTimer() {
      return this.$store.state.lowestTimer;
    },
  },
};
</script>
